export function clamp(num, min, max) {
    return num <= min ? min : num >= max ? max : num;
};

export function randInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);

    return Math.floor(Math.random() * (max - min + 1)) + min;
};

export function getSafeAreaInset() {
    return [
        "--safe-area-inset-top",
        "--safe-area-inset-right",
        "--safe-area-inset-bottom",
        "--safe-area-inset-left"
    ].map(prop => window.getComputedStyle(document.documentElement).getPropertyValue(prop) || '0px');
};